import { useState, useMemo } from 'react';
import SidePanel from '../../components/SidePanel';
import DenominationCounter from '../../components/ui/DenominationCounter';
import Dropdown from '../../components/receptura/Dropdown';

const NOMINALY = [2000, 1000, 500, 200, 100, 50, 20, 10, 5, 2, 1];
const prazdneDenom = () => NOMINALY.reduce((acc, n) => ({ ...acc, [n]: 0 }), {});

export default function ProvestAuditModal({ pokladna, isDark, onClose, onSaved }) {
    const [typ, setTyp] = useState('mimoradny');
    const [poznamka, setPoznamka] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const [isMobile] = useState(() => typeof window !== 'undefined' && window.innerWidth < 768);
    const token = document.querySelector('meta[name="csrf-token"]')?.content;

    // Počítadlo hotovosti — denom mapa (klikací režim) + manualAmount (ruční).
    const [denominace, setDenominace] = useState(prazdneDenom);
    const [manualAmount, setManualAmount] = useState(null);

    // Skutečný stav = ruční částka, nebo součet z denominací.
    const skutecnyStav = useMemo(() => {
        if (manualAmount !== null && manualAmount !== undefined) return Number(manualAmount || 0);
        return Object.entries(denominace).reduce((s, [nom, ks]) => s + Number(nom) * Number(ks || 0), 0);
    }, [denominace, manualAmount]);

    const handleSubmit = async () => {
        if (!skutecnyStav || skutecnyStav < 0) {
            alert('Spočítej hotovost — skutečný stav je 0.');
            return;
        }
        setSubmitting(true);
        try {
            const r = await fetch('/api/finance/pokladna/audity', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-CSRF-TOKEN': token },
                credentials: 'same-origin',
                body: JSON.stringify({
                    pokladna_id: pokladna.id,
                    skutecny_stav_kc: skutecnyStav,
                    typ,
                    poznamka: poznamka || null,
                }),
            });
            if (!r.ok) throw new Error(await r.text());
            onSaved?.();
        } catch (e) { alert('Audit selhal: ' + e.message); }
        setSubmitting(false);
    };

    return (
        <SidePanel open={true} onClose={onClose} title={`Audit — ${pokladna.nazev}`} isDark={isDark} isMobile={isMobile} width={420} modal={true}
            footer={
                <div className="flex gap-2">
                    <button onClick={onClose} className="px-4 py-2 rounded-lg text-sm" style={{ color: 'var(--text-secondary)' }}>Zrušit</button>
                    <button onClick={handleSubmit} disabled={submitting} className="flex-1 py-2 rounded-lg text-sm font-medium text-white" style={{ background: '#f59e0b', opacity: submitting ? 0.5 : 1 }}>
                        {submitting ? 'Ukládám…' : 'Uložit audit'}
                    </button>
                </div>
            }
        >
            <div className="p-5 space-y-3 text-sm" style={{ color: 'var(--text-primary)' }}>
                <p className="text-xs" style={{ color: 'var(--text-tertiary)' }}>
                    Spočítej fyzicky hotovost ve fleku — klikej na nominály, nebo přepni na ruční zadání.
                    {pokladna.uzavreny
                        ? ' Flek je uzavřený — systém porovná s hotovostí napočítanou při uzavření a rozdíl zapíše do auditů (stav fleku nemění).'
                        : ' Systém porovná s očekávaným stavem.'}
                </p>

                {/* Počítadlo bankovek/mincí — stejné jako na uzávěrce směny */}
                <DenominationCounter
                    denominace={denominace}
                    onChange={setDenominace}
                    manualAmount={manualAmount}
                    onManualAmountChange={setManualAmount}
                    ocekavanaCastka={pokladna.ocekavany_kc ?? null}
                    isDark={isDark}
                />

                <div>
                    <label className="text-xs font-medium mb-1 block" style={{ color: 'var(--text-secondary)' }}>Typ auditu</label>
                    <Dropdown value={typ} onChange={v => setTyp(v)}
                        options={[{ value: 'tydenni', label: 'Týdenní (pondělní)' }, { value: 'mesicni', label: 'Měsíční' }, { value: 'mimoradny', label: 'Mimořádný' }]}
                        isDark={isDark} accent="#3B82F6" height={38} />
                </div>
                <div>
                    <label className="text-xs font-medium mb-1 block" style={{ color: 'var(--text-secondary)' }}>Poznámka</label>
                    <textarea value={poznamka} onChange={e => setPoznamka(e.target.value)} placeholder="Volitelně…"
                        className="w-full rounded p-2 text-sm" style={{ background: 'var(--surface-base)', color: 'var(--text-primary)', border: '1px solid var(--border-default)', minHeight: 60 }} />
                </div>
            </div>
        </SidePanel>
    );
}
